export default "__VITE_ASSET__FG$UjCUh__"